module.exports = __webpack_public_path__ + "static/media/golfer-6-a.85298070.png";